import React from 'react';
import styled from 'styled-components';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import {Form, Input, Message} from 'semantic-ui-react';
import {useHistory} from 'react-router-dom';
import {PositiveButton} from '../../../components/mypage/MypageLayout';
// @ts-ignore
import {useRequestPasswordResetMutation} from 'api';

const validateSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .required('必須項目です')
    .email('メールアドレスの形式が不正です'),
});

const ResetPasswordForm = () => {
  const history = useHistory();
  const [
    requestResetPassword,
    {data, loading},
  ] = useRequestPasswordResetMutation({
    onCompleted: (data) => {
      if (!data?.requestPasswordReset?.error) {
        history.push('/reset_password/success');
      }
    },
  });

  const formik = useFormik({
    validationSchema: validateSchema,
    initialValues: {
      email: '',
    },
    onSubmit: (values) => {
      requestResetPassword({variables: values});
    },
  });

  return (
    <Container>
      <Title>パスワードの再設定</Title>

      {data?.requestPasswordReset?.error && (
        <Message negative>
          <p>{data.requestPasswordReset.error}</p>
        </Message>
      )}

      <div className="description">
        <p>登録に利用したパスワードを入力してください。</p>
        <p>パスワードを再設定するためのメールをお送りします。</p>
      </div>

      <Form onSubmit={formik.handleSubmit}>
        <Form.Field required className="field">
          <label>メールアドレス</label>
          <Input
            name="email"
            type="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.email && formik.errors.email && (
            <Message negative>{formik.errors.email}</Message>
          )}
        </Form.Field>

        <Actions>
          <PositiveButton
            positive
            type="submit"
            size="large"
            disabled={loading || !formik.dirty || !formik.isValid}>
            送信
          </PositiveButton>
        </Actions>
      </Form>
    </Container>
  );
};

export {ResetPasswordForm};

const Container = styled.div`
  padding-top: 90px;
  text-align: center;
  width: 400px;
  margin: 0 auto;

  .description {
    margin-top: 20px;
    margin-bottom: 40px;
    font-size: 12px;
    line-height: 1.5;
    color: #2c2c2c;

    p {
      margin-bottom: 0;
    }
  }

  .border {
    font-size: 13px;
    margin: 40px 0;
    height: 1px;
    border-top: solid 1px #999999;
    position: relative;

    p {
      position: absolute;
      top: -10px;
      left: 39%;
      background-color: #fff;
      width: 80px;
      text-align: center;
    }
  }

  label {
    text-align: left;
    opacity: 0.37;
    color: #333333;
    font-size: 12px;
  }

  input[type='email'],
  input[type='password'] {
    display: block;
    margin: 0 auto;
    width: 100%;
    height: 45px;
    background-color: #f5f5f5;
    border: solid 1px #f1f1f1;
  }

  .submit {
    margin: 40px;
  }
`;

const Title = styled.h1`
  margin-bottom: 70px;
  font-size: 26px;
  font-weight: 500;
  text-align: center;
  color: #666666;
`;

const Actions = styled.div`
  margin: 60px 0;

  button {
    width: 100%;
  }
`;
